var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('md-button',{staticClass:"md-info btn_nanosoft"},[_c('download-excel',{attrs:{"name":"تقرير صرف الرواتب عن شهر","stringifyLongNum":true,"fetch":_vm.fetchData,"fields":_vm.json_fields,"header":_vm.headerArray}},[_vm._v(" Excel ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }